import React from "react";
import Navbar from "../components/common/navbar";
import AppRouter  from "../Router";
import { useStore } from "../context/context";
import { useLocation } from "react-router-dom";

const App = () => {
  const { role } = useStore();
  const location = useLocation();
  const showNavbar = location.pathname !== "/";

  return (
    <main className="flex flex-col">
      {showNavbar && <Navbar />}
      <div className="w-full bg-secondary ">
        <div className="">
          <AppRouter role={role} />
        </div>
      </div>
    </main>
  );
};

export default App;
